import { render, staticRenderFns } from "./ProjectNavbar.vue?vue&type=template&id=fff5fc8a&scoped=true"
import script from "./ProjectNavbar.vue?vue&type=script&lang=js"
export * from "./ProjectNavbar.vue?vue&type=script&lang=js"
import style0 from "./ProjectNavbar.vue?vue&type=style&index=0&id=fff5fc8a&prod&lang=css"
import style1 from "./ProjectNavbar.vue?vue&type=style&index=1&id=fff5fc8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff5fc8a",
  null
  
)

export default component.exports